/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type UseConfigRecommendedSettings_WarningFragment = { __typename: 'ConfigSettingWarning', code: string, severity: Types.ConfigSettingWarningSeverity };

export type UseConfigRecommendedSettings_RecommendedSettingsFragment = { __typename: 'ConfigRecommendedSettings', recommended: boolean, warnings: Array<{ __typename: 'ConfigSettingWarning', code: string, severity: Types.ConfigSettingWarningSeverity }> };

export type UseConfigRecommendedSettings_ConfigFragment = { __typename: 'ConfigurationModel', id: string, recommendedSettings?: { __typename: 'ConfigRecommendedSettingsState', reported: { __typename: 'ConfigRecommendedSettings', recommended: boolean, warnings: Array<{ __typename: 'ConfigSettingWarning', code: string, severity: Types.ConfigSettingWarningSeverity }> } } | null };

export const UseConfigRecommendedSettings_WarningFragmentDoc = gql`
    fragment UseConfigRecommendedSettings_warning on ConfigSettingWarning {
  code
  severity
}
    `;
export const UseConfigRecommendedSettings_RecommendedSettingsFragmentDoc = gql`
    fragment UseConfigRecommendedSettings_recommendedSettings on ConfigRecommendedSettings {
  recommended
  warnings {
    ...UseConfigRecommendedSettings_warning
  }
}
    ${UseConfigRecommendedSettings_WarningFragmentDoc}`;
export const UseConfigRecommendedSettings_ConfigFragmentDoc = gql`
    fragment UseConfigRecommendedSettings_config on ConfigurationModel {
  id
  recommendedSettings {
    reported {
      ...UseConfigRecommendedSettings_recommendedSettings
    }
  }
}
    ${UseConfigRecommendedSettings_RecommendedSettingsFragmentDoc}`;